import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Module from "@/models/lms/Module";
import ModuleEntity from "@/models/lms-central/ModuleEntity";
import Course from "@/models/lms/Course";
import Media from "@/models/lms/Media";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export default class Lesson extends GenexLMSModel {
    static entity = "Modules\\Core\\Entities\\Lesson"

    static fields() {
        return {
            type:this.attr('lessons'),
            id: this.attr(null),
            order:this.attr(null),
            module_id: this.attr(null),
            module: this.belongsTo(Module, 'module_id'),
            course_id: this.attr(null),
            course: this.belongsTo(Course, 'course_id'),
            is_articulate_rise_lesson: this.attr(false),
            articulate_rise_url: this.attr(null),
            name: this.attr(null),
            display_name: this.attr(null),
            content: this.attr(null),
            json_content: this.attr({}),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            completed: this.attr(0),
            previous_lesson: this.attr(null),
            next_lesson: this.attr(null),
            media: this.hasManyBy(Media, 'media_ids'),
            media_ids: this.attr(() => []),
            video_url: this.attr(''),
            further_reading: this.attr(''),
            module_entity: this.morphMany(ModuleEntity, 'moduleable_id', 'moduleable_type'),
            date: this.attr(null),
            time: this.attr(null),
            // lesson_plan: this.belongsTo(LessonPlan, "lesson_plan_id"),
            articulate_audio_url: this.attr(null),
            has_articulate_audio: this.attr(null),
            lesson_type_id: this.attr(null),
        }
    }
    /**
     * Completes a lesson
     * @function
     * @param {number} course_id -
     * @param {number} module_id -
     * @param {number} lesson_id -
     * @param {?number} difficulty - The difficulty level. 1 = difficult, 2 = mastered, 3 = needs_more
     * @returns {Promise<Response>}
     */

    static Complete(course_id, module_id, lesson_id,difficulty=null) {
        return this.api().post(`lessons/${lesson_id}/complete`, {
                course_id: course_id,
                module_id: module_id,
                difficulty: difficulty
            }, {
            ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                dataTransformer: ({data: {data}}) => {
                    if (data === null) {
                        return {id: lesson_id, completed: 1}
                    }
                    return [Object.assign(data, data.attributes), {id: lesson_id, completed: 1}]

                },
            }
        )
    }

    /**
     * Mark a lesson as incomplete
     * @function
     * @param {number} course_id -
     * @param {number} module_id -
     * @param {number} lesson_id -
     * @returns {Promise<Response>}
     */

    static Uncomplete(course_id, module_id, lesson_id) {
        return this.api().post(`lessons/${lesson_id}/incomplete`, {course_id: course_id, module_id: module_id}, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                dataTransformer: ({data: {data}}) => {
                    return Object.assign(data, data.attributes)
                },
            }
        )
    }

    /**
     * Returns a lesson
     * @function
     * @param {number} course_id - The course_id
     * @param {number} module_id - The module_id
     * @param {number} lesson_id - The lesson_id
     * @param {Array.<string>} [relationships=[]] - Relationships to bring along
     * @returns {Promise<Response>}
     */

    static FetchById(course_id, module_id, lesson_id, relationships = []) {
        return this.api().get(`/lessons/${lesson_id}`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        with: relationships, module_id: module_id, course_id: course_id
                    },
                },
                dataTransformer: ({data: {data}}) => {

                    if (relationships.includes('user')) {
                        Object.assign(data.attributes.user, data.attributes.user.attributes)
                    }
                    return {...data, ...data.attributes}
                },
            }
        )
    }


    /**
     * Search for lessons
     * @function
     * @returns {Promise<Response>}
     */

    static search(query,courseId=null) {
        return this.api().get(`/lessons/search`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        search: query,
                        course_id:courseId
                    },
                },
                dataTransformer: ({data: {data}}) => {

                    return {...data}
                },
            }
        )
    }

    /**
     * @param page
     * @param limit
     * @param query
     * @param relationships
     * @returns {*}
     * @constructor
     */
    static FetchAll({page = 1, limit = 15}, query = {}, relationships = []) {
        return this.api().get(`/lessons`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        page: page, limit: limit, with: relationships
                    }, ...(query !== {} ? query : {}),
                },
                dataTransformer: ({data: {data}}) => {
                    return data.map(course => {
                        return {...course, ...course.attributes}
                    })
                },
            }
        )
    }



}
